export default "__VITE_ASSET__505ab479__"